export class CustomerAccess {
    id: string;
    addedDate: any;
    clientId: string;
    email: string;
    sites: string[];
    name: string;
    phoneNumber: string;
}